import { render, staticRenderFns } from "./SetLocale.vue?vue&type=template&id=9427933a&"
import script from "./SetLocale.vue?vue&type=script&lang=js&"
export * from "./SetLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports